import Vue from 'vue'
import VueFlicking from "@egjs/vue-flicking";
//import "@egjs/vue-flicking/dist/flicking.css";
import pressAndLongPress from 'vue-press-and-long-press'
import VueTyperPlugin from 'vue-typer'

Vue.use(VueFlicking);
Vue.use(pressAndLongPress);
Vue.use(VueTyperPlugin);

//icon
Vue.component('IconClose', () => import('@/components/icons/Close.vue'))
Vue.component('WeatherNew', () => import('@/components/icons/WeatherNew.vue'))

//common
Vue.component('LoadImage', () => import('@/components/common/Image.vue'))
Vue.component('Loading', () => import('@/components/common/Loading.vue'))
Vue.component('NoData', () => import('@/components/common/NoData.vue'))

//layout
Vue.component('AppBar', () => import('@/components/layout/AppBarNew.vue'))
Vue.component('BottomSheet', () => import('@/components/layout/bottomSheet/BottomSheet.vue'))
